import { Translation } from '@/types/directus'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Shared feed-domain debug logger. Pass a scope tag and an arbitrary payload. */
export function logFeedDebug(scope: string, payload: Record<string, unknown>) {
  // eslint-disable-next-line no-console
  console.info(`[feed] ${scope}`, payload)
}

export function logFeedLikeLoginDebug(payload: Record<string, unknown>) {
  logFeedDebug('like-login', payload)
}

export type HeaderTab = 'VIVERSE' | 'PROFILE' | 'CREATE' | 'PLUS'

export function getHeaderTab(pathname: string): HeaderTab {
  switch (true) {
    case pathname.includes('/plus'):
      return 'PLUS'
    case pathname.includes('/profile/'):
      return 'PROFILE'
    default:
      return 'VIVERSE'
  }
}

export function applyHyphen(string: string) {
  return string?.replace('_', '-')
}

export function applyUnderline(string: string) {
  return string?.replace('-', '_')
}

export function getTranslatedName<T = string>(
  translations: Translation<T>[] = [],
  locale: string,
  defaultName: T,
): T {
  const translation = translations.find((t) => t.languages_code === locale)

  if (translation) {
    return translation.name
  }

  return defaultName
}
